import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { setAdminAuthToken, setApiUrl, setApiStore } from '../services/api';
import { logger } from './middleware';

const sagaMiddleware = createSagaMiddleware();

// Configuration pour Redux DevTools avec logging
const composeEnhancers =
    typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? composeWithDevTools({
            trace: true,
            traceLimit: 25,
        })
        : compose;

// Initialiser le token admin et l'URL API depuis le localStorage
const savedAdminToken = localStorage.getItem('admin_access_token');
const savedEnv = localStorage.getItem('apiEnv') || 'dev';

if (savedAdminToken) {
    setAdminAuthToken(savedAdminToken);
}
setApiUrl(savedEnv);

// Créer le store avec les middlewares (logger et saga)
const middlewares = [sagaMiddleware];

// Ajouter le logger uniquement en développement
if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
);

sagaMiddleware.run(rootSaga);

setApiStore(store);

// Exposer le store globalement pour un accès facile depuis la console du navigateur
if (process.env.NODE_ENV === 'development') {
    window.__REDUX_STORE__ = store;

    // Fonctions utilitaires pour logger l'état depuis la console
    window.logReduxState = () => {
        console.log('%c Current Redux State:', 'color: #00cc00; font-size: 16px; font-weight: bold', store.getState());
        return store.getState();
    };

    window.logReduxAuth = () => {
        const authState = store.getState().adminAuth;
        console.log('%c Admin Auth State:', 'color: #0099ff; font-size: 14px; font-weight: bold', authState);
        return authState;
    };

    window.logReduxAdminAuth = () => {
        const adminAuthState = store.getState().adminAuth;
        console.log('%c Admin Auth State:', 'color: #0099ff; font-size: 14px; font-weight: bold', adminAuthState);
        return adminAuthState;
    };

    window.logReduxData = () => {
        const dataState = store.getState().data;
        console.log('%c Data State:', 'color: #ff9900; font-size: 14px; font-weight: bold', dataState);
        return dataState;
    };

    window.dispatchAction = (action) => {
        console.log('%c Dispatching Action:', 'color: #ff0066; font-size: 14px; font-weight: bold', action);
        return store.dispatch(action);
    };

    // Afficher un message d'aide
    console.log(
        '%c Redux DevTools Loaded!',
        'color: #00cc00; font-size: 18px; font-weight: bold; padding: 10px;'
    );
    console.log(
        '%c Available commands:\n' +
        '  - window.logReduxState() - Log tout l\'état Redux\n' +
        '  - window.logReduxAuth() - Log uniquement l\'état adminAuth\n' +
        '  - window.logReduxAdminAuth() - Log uniquement l\'état adminAuth\n' +
        '  - window.logReduxData() - Log uniquement l\'état data\n' +
        '  - window.dispatchAction(action) - Dispatch une action\n' +
        '  - window.__REDUX_STORE__ - Accès direct au store',
        'color: #666; font-size: 12px; padding: 5px;'
    );
}

export default store;

